import { render } from "./vendorsheader.vue?vue&type=template&id=9f8123f0"
import script from "./vendorsheader.vue?vue&type=script&lang=js"
export * from "./vendorsheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__